// extracted by mini-css-extract-plugin
export default {"video_image":"VideoImage-module__video_image"};